import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import * as types from '../mutation-types';
import FeatureFlagAPI from '../../api/featureFlag';

const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isFetchingItem: false,
    isUpdating: false,
    isCheckoutInProcess: false,
  },
};

export const getters = {
  getFeatureFlag: $state => () => {
    return $state.records || {};
  },
};

export const actions = {
  get: async ({ commit }) => {
    commit(types.default.SET_FEATURE_FLAG, { isFetchingItem: true });
    try {
      const response = await FeatureFlagAPI.get();
      commit(types.default.ADD_FEATURE_FLAG, response.data);
      commit(types.default.SET_FEATURE_FLAG, {
        isFetchingItem: false,
      });
    } catch (error) {
      commit(types.default.SET_FEATURE_FLAG, {
        isFetchingItem: false,
      });
    }
  },
};

export const mutations = {
  [types.default.SET_FEATURE_FLAG]($state, data) {
    $state.uiFlags = {
      ...$state.uiFlags,
      ...data,
    };
  },
  [types.default.ADD_FEATURE_FLAG]: MutationHelpers.setSingleRecord,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
